export const FILL_BAG_DEFAULT_INPUTS = {
  weight: '1',
  fillDate: new Date(),
  parameters: {},
  wheatType: undefined,
  weed: '0',
  admixtureOtherCereals: '0',
  wheatDifferentType: '0',
  description: '',
  custom_name: '',
} as {
  weight: string;
  fillDate: Date | null;
  parameters: Record<number, string>;
  wheatType?: number;
  weed: string;
  admixtureOtherCereals: string;
  wheatDifferentType: string;
  description: string;
  custom_name: string | number;
};
